import { intensityForLevel, type LevelIntensity } from '../generation/curve';

/**
 * 難易度のイメージ色。難易度 → 色の対応はここが唯一の出所で、CSS 側の
 * `--grade-*` トークンと Phaser 側の盤面下地はどちらもこの表から引く
 * （CSS は値を書き写しているので difficultyPalette.test.ts が一致を見張る）。
 *
 * 機能色（コーラル 0xec7669 = 失敗 / 琥珀 0xefbf6c = ヒント /
 * ティール 0x60cdb5 = 進行）とは役割が違うので、取り違えないよう
 * 色相と明度の両方で離してある。
 */
export interface DifficultyTone {
  /** 濃紺のシェル・盤面へ載せる明色版。 */
  readonly hex: string;
  /** オフホワイトの図面（--paper）へ載せる濃色版。 */
  readonly ink: string;
}

export const difficultyTones: Readonly<Record<LevelIntensity, DifficultyTone>> = {
  // 空。ティールより青く、図面の製図線（--blueprint）よりも明るい。
  normal: { hex: '#63c2f7', ink: '#0a6ab4' },
  // 菫。機能色のどれとも色相が重ならない帯。
  hard: { hex: '#b7a6f7', ink: '#6a4fc4' },
  // 紅紫。コーラルとは色相で 60° 以上離し、彩度を上げて別物と読ませる。
  superhard: { hex: '#f27cd3', ink: '#b02292' },
};

export function difficultyToneForLevel(levelNumber: number): DifficultyTone {
  return difficultyTones[intensityForLevel(levelNumber)];
}

function toPhaserColor(hex: string): number {
  return Number.parseInt(hex.slice(1), 16);
}

/** Phaser（0xRRGGBB）向けの明色版。盤面の下地の味付けに使う。 */
export function difficultyColorForLevel(levelNumber: number): number {
  return toPhaserColor(difficultyToneForLevel(levelNumber).hex);
}
